import React from 'react';
import presets, { colors } from '../utils/presets';
import { options, rhythm, scale } from '../utils/typography';

const navItemStyles = {
  ...scale(-1 / 3),
  boxSizing: `border-box`,
  display: `inline-block`,
  color: `inherit`,
  textDecoration: `none`,
  letterSpacing: `0.03em`,
  lineHeight: `calc(${presets.headerHeight} - 6px)`,
  padding: `6px ${rhythm(1 / 4)} 0`,
  position: `relative`,
  top: 0,
  transition: `color .15s ease-out`,
  '&&': {
    borderBottom: `initial`,
    boxShadow: `initial`,
  },
  '&&:hover': {
    backgroundColor: `transparent`,
    opacity: 0.8,
  },
};

const Footer = () => {
  const styles = {};
  const gutters = {};

  return (
    <footer
      css={{
        backgroundColor: presets.colors.charcoal,
        left: 0,
        right: 0,
        ...styles,
        marginBottom: `${presets.mobileNavigationHeight}`,
        [presets.Tablet]: {
          marginBottom: `initial`,
        },
      }}
    >
      <div
        css={{
          margin: `0 auto`,
          paddingLeft: rhythm(3 / 4),
          paddingRight: rhythm(3 / 4),
          ...gutters,
          fontFamily: options.headerFontFamily.join(`,`),
          display: `flex`,
          justifyContent: `center`,
          alignItems: `center`,
          width: `100%`,
          height: `100%`,
        }}
      >
        <div
          css={{
            display: `flex`,
            justifyContent: `center`,
            color: colors.chromium,
            flexFlow: `wrap`,
          }}
        >
          <div css={{ ...navItemStyles, '&&:hover': null }}>
            {`Copyright © ${new Date().getFullYear()} Zoomdata™ All Rights Reserved`}
          </div>
          <a href="https://www.zoomdata.com/" css={{ ...navItemStyles }}>
            <div style={{ verticalAlign: `text-top` }}>Zoomdata.com</div>
          </a>
          <span css={{ ...navItemStyles, '&:hover': null }}>|</span>
          <a
            href="https://www.zoomdata.com/terms-of-use/"
            css={{ ...navItemStyles }}
          >
            <div style={{ verticalAlign: `text-top` }}>Terms of Use</div>
          </a>
          <span css={{ ...navItemStyles, '&:hover': null }}>|</span>
          <a
            href="https://www.zoomdata.com/privacy-policy/"
            css={{ ...navItemStyles }}
          >
            <div style={{ verticalAlign: `text-top` }}>Privacy Policy</div>
          </a>
          <span
            css={{
              ...navItemStyles,
              '&:hover': null,
            }}
          >
            |
          </span>
          <a
            href="https://www.zoomdata.com/equal-opportunity-employer/"
            css={{ ...navItemStyles }}
          >
            <div style={{ verticalAlign: `text-top` }}>EOM Statement</div>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
